import imageCompte from '../assets/images/img-compte.png';

const imgCompte = () => {
  return (
    <div
        className="h-full w-full bg-cover bg-center rounded-t-xl"
      style={{ backgroundImage: `url(${imageCompte})` }}
    >           
    </div>
  );
};

export default imgCompte;
